import { Button, ButtonProps } from "src/components/base/button";
import { WfLinkUnstyled } from "src/components/base/wf-link";
import { ExpandableTags } from "src/components/common/expandable-tags/expandable-tags";
import { getVariant } from "src/components/feed-card/content-blocks/categories/use-map-category-props";
import { IFeedCardCategory, TFeedCardCategoriesBody } from "src/components/feed-card/types/content";

const TAGS_INITIAL_MAX_HEIGHT = 72;
export interface IFeedCardCategoriesProps {
    categories: TFeedCardCategoriesBody;
}

export const FeedCardCategories = ({ categories }: IFeedCardCategoriesProps) => (
    <ExpandableTags initialMaxHeight={TAGS_INITIAL_MAX_HEIGHT} mb={3}>
        {categories.map((category, index) => (
            <FeedCardCategory key={index} {...category} />
        ))}
    </ExpandableTags>
);

const FeedCardCategory = ({ text, color, variant: initialVariant, url, ...props }: IFeedCardCategory) => {
    const variant = getVariant(initialVariant);

    const resetBgProps = {
        bg: undefined,
    };

    const buttonProps: ButtonProps = {
        ...props,
        size: "xs",
        rounded: "16px",
        children: text,
        colorScheme: color,
        variant,
        cursor: "auto",
        _hover: resetBgProps,
        _active: resetBgProps,
        _focus: resetBgProps,
    };

    return url ? (
        <WfLinkUnstyled href={url}>
            <Button {...buttonProps} />
        </WfLinkUnstyled>
    ) : (
        <Button {...buttonProps} />
    );
};
